// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E7CGyG6j8p {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.E7CGyG6j8p h4 {
  line-height: 3em;
}
.E7CGyG6j8p .RJA0gN77I9 {
  float: left;
  width: 100%;
}
.E7CGyG6j8p .tUOtaSAmHr {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.E7CGyG6j8p .tUOtaSAmHr:hover {
  cursor: pointer;
}
.E7CGyG6j8p .tUOtaSAmHr:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.CASbSPeEKC .uNNnASW325:focus {
  outline: none;
}
.CASbSPeEKC .uNNnASW325.zzsrEc46Y6.Whv_0jHEa1 {
  background: #375A88;
}
.CASbSPeEKC .uNNnASW325.zzsrEc46Y6.Whv_0jHEa1 span {
  color: #fff;
}
.CASbSPeEKC .Whv_0jHEa1 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.CASbSPeEKC .Whv_0jHEa1:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.CASbSPeEKC input {
  height: 38px;
  min-width: 220px;
}
.tUOtaSAmHr.wJBLrClGWx {
  background: #410102;
}
.tUOtaSAmHr.sXjtYYIvbK {
  background: #911318;
}
.tUOtaSAmHr.dYsp511hwH {
  background: #D8293B;
}
.tUOtaSAmHr.tdUbgiOKn0 {
  background: #F2373C;
}
.tUOtaSAmHr.hl4CX8v3m4 {
  background: #FC4448;
}
.tUOtaSAmHr.vaHMiuNA1u {
  background: #ED535E;
}
.tUOtaSAmHr.XmLV4RpYRS {
  background: #E34926;
}
.tUOtaSAmHr.mmY3xm6Rx1 {
  background: #FC562B;
}
.tUOtaSAmHr.T1o7LSpqG4 {
  background: #FC6722;
}
.tUOtaSAmHr.L8BQ5b_UUc {
  background: #FD7F24;
}
.tUOtaSAmHr.aTOmgINJoM {
  background: #FD8D26;
}
.tUOtaSAmHr.XS9MNtqHE0 {
  background: #EC9C3E;
}
.tUOtaSAmHr.gMLzMfkgGb {
  background: #0e673a;
}
.tUOtaSAmHr.oMQfSehL19 {
  background: #208740;
}
.tUOtaSAmHr.SEqnSgXhCL {
  background: #239718;
}
.tUOtaSAmHr.wV2mHT3Cdj {
  background: #55A84D;
}
.tUOtaSAmHr.i0tcKYRUtb {
  background: #4BBE5A;
}
.tUOtaSAmHr.HzNA_0Y8pf {
  background: #0CCA6A;
}
.tUOtaSAmHr.kfoHMno3B1 {
  background: #0A3C64;
}
.tUOtaSAmHr.HlIkdVG_Cg {
  background: #0d487a;
}
.tUOtaSAmHr.C9WLdr0DuX {
  background: #10538d;
}
.tUOtaSAmHr.BbTXYXIEIS {
  background: #115A99;
}
.tUOtaSAmHr.tqXcgsaxu9 {
  background: #3387E2;
}
.tUOtaSAmHr.fePi39uy2U {
  background: #1BA9CF;
}
.tUOtaSAmHr.kpGIVB7cB5 {
  background: #d27c02;
}
.tUOtaSAmHr.q4BWQVdrnD {
  background: #fb9402;
}
.tUOtaSAmHr.on4haAx2HW {
  background: #FD9B30;
}
.tUOtaSAmHr.fzwcd227J2 {
  background: #FDBE2D;
}
.tUOtaSAmHr.mYOmZ9CVgx {
  background: #FED831;
}
.tUOtaSAmHr.N638F8XuJ4 {
  background: #FFFD38;
}
.tUOtaSAmHr.MEdYniI9Iz {
  background: #2D215C;
}
.tUOtaSAmHr.x3hQtbaymp {
  background: #483C83;
}
.tUOtaSAmHr.I5_k2L7z2p {
  background: #58518d;
}
.tUOtaSAmHr.EnY12rau51 {
  background: #7068A9;
}
.tUOtaSAmHr.tKqSWUCW1x {
  background: #7f78b2;
}
.tUOtaSAmHr.WIHCbsK39r {
  background: #8f88bc;
}
.tUOtaSAmHr.iCT_FMFW7j {
  background: #000;
}
.tUOtaSAmHr.A3swuKRyoR {
  background: #282626;
}
.tUOtaSAmHr.ZZ7Uf5EWAe {
  background: #242222;
}
.tUOtaSAmHr.F7D0Ij1iHS {
  background: #353838;
}
.tUOtaSAmHr.Gmq6im70WM {
  background: #666;
}
.tUOtaSAmHr._0_rS2VNdD {
  background: #999;
}
.g0BSrSSCWZ {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.g0BSrSSCWZ .RQj_G8x99H {
  display: none;
}
.yByrixqxu0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;
  height: 36px;
  align-items: unset;
  padding: 12px 16px;
}
.yByrixqxu0:last-child {
  border-bottom: none;
}
.yByrixqxu0 .efX2gEM6Yo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: unset;
  width: 100%;
  font-size: 11px;
  line-height: 15px;
  color: #212121;
}
.yByrixqxu0 .efX2gEM6Yo .ZvfTOwahFR {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 4;
}
.yByrixqxu0 .eGd3Wgi0U_ {
  justify-content: unset;
}
.yByrixqxu0 .eGd3Wgi0U_ .M0EGEDkP6w {
  padding: 0;
  border: none;
}
.yByrixqxu0 .eGd3Wgi0U_ .M0EGEDkP6w::placeholder {
  font-size: 11px;
}
.yByrixqxu0 .FgWletjJ8v {
  flex: 1;
  font-size: 12px;
  display: none;
  text-align: end;
}
.yByrixqxu0 .zD8yGtbf4S {
  display: block;
  flex: unset;
  margin-right: 4px;
}
.yByrixqxu0 .VHrCiQBf3j {
  visibility: hidden;
  display: block;
  margin-left: 4px;
}
.yByrixqxu0:hover:not(.YaugylSOy9) {
  background-color: #FFF4D9;
}
.yByrixqxu0:hover:not(.YaugylSOy9) .FgWletjJ8v {
  visibility: visible;
}
.OAmKiAgCYm {
  border-radius: 4px;
  height: 32px;
  margin: auto;
  width: 96%;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `E7CGyG6j8p`,
	"color-row": `RJA0gN77I9`,
	"color-tile": `tUOtaSAmHr`,
	"picker-component": `CASbSPeEKC`,
	"picker-element": `uNNnASW325`,
	"active": `zzsrEc46Y6`,
	"btn": `Whv_0jHEa1`,
	"red-1": `wJBLrClGWx`,
	"red-2": `sXjtYYIvbK`,
	"red-3": `dYsp511hwH`,
	"red-4": `tdUbgiOKn0`,
	"red-5": `hl4CX8v3m4`,
	"red-6": `vaHMiuNA1u`,
	"orange-1": `XmLV4RpYRS`,
	"orange-2": `mmY3xm6Rx1`,
	"orange-3": `T1o7LSpqG4`,
	"orange-4": `L8BQ5b_UUc`,
	"orange-5": `aTOmgINJoM`,
	"orange-6": `XS9MNtqHE0`,
	"green-1": `gMLzMfkgGb`,
	"green-2": `oMQfSehL19`,
	"green-3": `SEqnSgXhCL`,
	"green-4": `wV2mHT3Cdj`,
	"green-5": `i0tcKYRUtb`,
	"green-6": `HzNA_0Y8pf`,
	"blue-1": `kfoHMno3B1`,
	"blue-2": `HlIkdVG_Cg`,
	"blue-3": `C9WLdr0DuX`,
	"blue-4": `BbTXYXIEIS`,
	"blue-5": `tqXcgsaxu9`,
	"blue-6": `fePi39uy2U`,
	"yellow-1": `kpGIVB7cB5`,
	"yellow-2": `q4BWQVdrnD`,
	"yellow-3": `on4haAx2HW`,
	"yellow-4": `fzwcd227J2`,
	"yellow-5": `mYOmZ9CVgx`,
	"yellow-6": `N638F8XuJ4`,
	"purple-1": `MEdYniI9Iz`,
	"purple-2": `x3hQtbaymp`,
	"purple-3": `I5_k2L7z2p`,
	"purple-4": `EnY12rau51`,
	"purple-5": `tKqSWUCW1x`,
	"purple-6": `WIHCbsK39r`,
	"black-1": `iCT_FMFW7j`,
	"black-2": `A3swuKRyoR`,
	"black-3": `ZZ7Uf5EWAe`,
	"black-4": `F7D0Ij1iHS`,
	"black-5": `Gmq6im70WM`,
	"black-6": `_0_rS2VNdD`,
	"picker-theme": `g0BSrSSCWZ`,
	"arrow-regular": `RQj_G8x99H`,
	"templates__item": `yByrixqxu0`,
	"item__root": `efX2gEM6Yo`,
	"item__content": `ZvfTOwahFR`,
	"item__root--feature": `eGd3Wgi0U_`,
	"input-search": `M0EGEDkP6w`,
	"item__icon": `FgWletjJ8v`,
	"item__icon--feature": `zD8yGtbf4S`,
	"item__icon--available": `VHrCiQBf3j`,
	"templates__item--feature": `YaugylSOy9`,
	"skeletonOption": `OAmKiAgCYm`
};
export default ___CSS_LOADER_EXPORT___;
